import { changeAuthNumber, logoutAction, setActiveModalAction } from '../../actions';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = '';

export default createReducer(
  [
    forAction(changeAuthNumber, identityPayload),
    forAction(setActiveModalAction, (state, { payload }) => {
      const { field, value } = payload;

      if (field === 'auth' && !value) {
        return initialState;
      }

      return state;
    }),
  ],
  initialState,
  [logoutAction],
);
